import { render } from "./PopupFormStatus.vue?vue&type=template&id=865cc2aa&scoped=true"
import script from "./PopupFormStatus.vue?vue&type=script&lang=js"
export * from "./PopupFormStatus.vue?vue&type=script&lang=js"

import "./PopupFormStatus.vue?vue&type=style&index=0&id=865cc2aa&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-865cc2aa"]])

export default __exports__